import templateUrl from "emun.cust/details/cust-details.htm";
import controller from "emun.cust/details/cust-details.controller";
import "emun.cust/details/cust-details.scss";

export default {
  bindings: {
    customerId: "@",
    mode: "@",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
